<template>
  <el-row>
    <el-col :span="24">
      <div id="reports" style="width: 100%; height: 520px">加载中..</div>
    </el-col>
  </el-row>
</template>

<script>
import api from "@/api/exams/exams/answers.js";
import * as echarts from "echarts";

export default {
  name: "exams",
  components: {
    echarts,
  },
  data() {
    return {
      echart1: {},
      examCnt: 0,
      option: {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          max: 100,
        },
        yAxis: {
          type: "category",
        },
        series: [
          {
            name: "得分比",
            type: "bar",
            //data: [76, 63, 72, 56, 25, 56, 87, 98, 100],

            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "#fff",
                    fontSize: 20,
                    fontWeight: 400,
                  },
                },
                //可以设置每个柱上方显示数字
                color: function (params) {
                  //柱状图设置不同颜色
                  // 给出颜色组
                  if (params.data < 60) {
                    return "#ee6767";
                  } else if (params.data < 75) {
                    return "#4a77dd";
                  } else if (params.data < 85) {
                    return "#fac859";
                  } else {
                    return "#92cc76";
                  }
                },
              },
            },
          },
        ],
      },
    };
  },

  methods: {
    init() {
      //获取数据
      //从本地会话拿到学生id跟学生name
      let sid = JSON.parse(sessionStorage.getItem("user"));

      let stuid = sid.id; //学生id
      this.myname = sid.name; //学生name

      api.cntSubScore({ stuid }, (response) => {
        this.option.title.text = "理论-模块能力测评报告";
        this.option.series[0].data = response.data.seriesData;
        this.option.series[0].name = "统计样本（只取最后一次）"+response.data.examCnt+"/"+response.data.examCntAll
        this.option.yAxis.data = response.data.yAxisData;
        this.kidList = response.data.kidList;

        this.echart1 = echarts.init(document.getElementById("reports"));

        this.echart1.setOption(this.option);
        let that = this

        this.echart1.on("click", function (params) {
   
          if (params.value && that.option.title.text == "理论-模块能力测评报告") {
            let kid = that.kidList[params.dataIndex];
            //console.log(kid);
            api.cntSubScore({ stuid, kid }, (response) => {
              that.option.title.text = "科目能力评价";
              that.option.series[0].data = response.data.seriesData;
              that.option.series[0].name ="统计样本（只取最后一次）"+response.data.examCnt+"/"+response.data.examCntAll
              that.option.yAxis.data = response.data.yAxisData;
              that.kidList = response.data.kidList;
              that.echart1 = echarts.init(document.getElementById("reports"));

              that.echart1.setOption(that.option);
            }
            );
          } else {
            //back
            api.cntSubScore({ stuid }, (response) => {
              that.option.title.text = "理论-模块能力测评报告";
              that.option.series[0].data = response.data.seriesData;
              that.option.series[0].name = "统计样本（只取最后一次）"+response.data.examCnt+"/"+response.data.examCntAll
              that.option.yAxis.data = response.data.yAxisData;
              that.kidList = response.data.kidList;
              that.echart1 = echarts.init(document.getElementById("reports"));

              that.echart1.setOption(that.option);
            });
          }
        });
      });
    },
  },
  mounted() {
    this.init();
    console.log("init事件触发");
  },

};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>